export interface DNSInfoModel {
  type: string | null;
  host: string | null;
  value: string | null;
  is_valid: boolean | null;
}

export interface CompanyDomainDNSModel {
  id: string;
  company_id: string;
  domain: string | null;
  is_valid: boolean | null;
  error_message: string | null;
  records: DNSInfoModel[] | null;
}

export interface CompanyDomainsDNSValidationModel {
  id: string;
  company_id: string;
  domain: string | null;
  is_valid: boolean | null;
  error_message: string | null;
  records: DNSInfoModel[] | null;
}
